var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-12" },
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-tabs",
            {
              attrs: { card: "", lazy: "" },
              model: {
                value: _vm.tabIndex,
                callback: function($$v) {
                  _vm.tabIndex = $$v
                },
                expression: "tabIndex"
              }
            },
            [
              _vm.hasPermission("list_bi_abelha")
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        title: "Abelha",
                        "title-link-class": _vm.linkClass(0)
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-embed", {
                            attrs: {
                              type: "iframe",
                              aspect: "16by9",
                              src:
                                "https://app.powerbi.com/view?r=eyJrIjoiNThjYzA0NTgtMGFkYi00ZDYyLTk2YWQtNzYwNDI2YWZiMjY1IiwidCI6IjA2N2Y1YTJjLWM2ZTQtNGY0Zi1hMThhLTk1ZmJmYjJkODNlMiJ9",
                              allowfullscreen: ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list_bi_lojas_personalizadas")
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        title: "Lojas Personalizadas",
                        "title-link-class": _vm.linkClass(1)
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-embed", {
                            attrs: {
                              type: "iframe",
                              aspect: "16by9",
                              src:
                                "https://app.powerbi.com/view?r=eyJrIjoiNDJkYzE0NzEtMTQ0ZS00NDAxLWIzZDAtZmYyMTJiYzBjMGJhIiwidCI6IjA2N2Y1YTJjLWM2ZTQtNGY0Zi1hMThhLTk1ZmJmYjJkODNlMiJ9",
                              allowfullscreen: ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list_bi_farma")
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        title: "Farma",
                        "title-link-class": _vm.linkClass(2)
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-embed", {
                            attrs: {
                              type: "iframe",
                              aspect: "16by9",
                              src:
                                "https://app.powerbi.com/reportEmbed?reportId=be804adb-501f-463a-9664-45419f82b035&autoAuth=true&ctid=067f5a2c-c6e4-4f4f-a18a-95fbfb2d83e2",
                              allowfullscreen: ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list_bi_ocorrencia")
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        title: "Ocorrências",
                        "title-link-class": _vm.linkClass(3)
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-embed", {
                            attrs: {
                              type: "iframe",
                              aspect: "16by9",
                              src:
                                "https://app.powerbi.com/view?r=eyJrIjoiY2U3MDRmZGEtY2NlYi00NzcxLWIyOTctMTUwN2ViMTU2MTNlIiwidCI6IjA2N2Y1YTJjLWM2ZTQtNGY0Zi1hMThhLTk1ZmJmYjJkODNlMiJ9",
                              allowfullscreen: ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list_bi_prospecto")
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        title: "Prospectos",
                        "title-link-class": _vm.linkClass(4)
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-embed", {
                            attrs: {
                              type: "iframe",
                              aspect: "16by9",
                              src:
                                "https://app.powerbi.com/view?r=eyJrIjoiMDNhZWFhNDAtZjAyYS00OTNjLWE4NDEtOGFkNzA5ZDNmNmI1IiwidCI6IjA2N2Y1YTJjLWM2ZTQtNGY0Zi1hMThhLTk1ZmJmYjJkODNlMiJ9",
                              allowfullscreen: ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35fa0476", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35fa0476","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_bi/Main.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-35fa0476","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_bi/Main.vue
// module chunks = 2